import { CircularProgress, Grid, Typography } from '@mui/material';
import './index.css';
type LoadingProps = {
  text?: string;
};
const Loading = ({ text }: LoadingProps) => {
  if (!text) {
    text = 'Loading';
  }
  return (
    <div className="Loading">
      <Grid>
        <Typography variant="h5">{text}</Typography>
        <br />
        <div>
          <CircularProgress />
        </div>
      </Grid>
    </div>
  );
};

export default Loading;
